import ISpineAnimConfig from '../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimConfig';
import AbstractBaseSpineAnimationsConfig from '../../vendor_core/core/src/baseConfigs/AbstractSceneSpineAnimationsConfig';
import ISceneSpineAnimConfig from '../../vendor_core/core/src/managers/contracts/configurations/ISceneSpineAnimConfig';

class SpineAnimationsConfig extends AbstractBaseSpineAnimationsConfig implements ISceneSpineAnimConfig {
    anims: ISpineAnimConfig[] = [
        {
            name: "bigWin",
            hasSkins: false,
            states: [
                {
                    name: "bigwin_loop",
                    loop: false
                },
                {
                    name: "bigwin_end",
                    loop: false
                },
                {
                    name: "superwin_loop",
                    loop: false
                },
                {
                    name: "superwin_end",
                    loop: false
                },
                {
                    name: "megawin_loop",
                    loop: false
                },
                {
                    name: "megawin_end",
                    loop: false
                },
                {
                    name: "epicwin_loop",
                    loop: false
                },
                {
                    name: "epicwin_end",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "bigwin_loop",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "totalWins",
            hasSkins: false,
            states: [
                {
                    name: "ante_win",
                    loop: false
                },
                {
                    name: "small_win",
                    loop: false
                },
                {
                    name: "nice_win",
                    loop: false
                },
                {
                    name: "excellent_win",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "ante_win",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "anticipation",
            hasSkins: false,
            states: [
                {
                    name: "animation",
                    loop: true
                },
                {
                    name: "animation_purple",
                    loop: true
                }
            ],
            visible: false,
            defaultState: "animation",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "animation",
            hasSkins: false,
            states: [
                {
                    name: "main_loop",
                    loop: true
                },
                {
                    name: "main_loop_pt",
                    loop: true
                },
                {
                    name: "BN1_loop",
                    loop: true
                },
                {
                    name: "BN1_loop_pt",
                    loop: true
                },
                {
                    name: "BN1_start",
                    loop: false
                },
                {
                    name: "BN1_start_pt",
                    loop: false
                },
                {
                    name: "BN1_loop_win",
                    loop: true
                },
                {
                    name: "BN1_loop_win_pt",
                    loop: true
                },
                {
                    name: "BN2_loop",
                    loop: true
                },
                {
                    name: "BN2_loop_pt",
                    loop: true
                },
                {
                    name: "BN2_start",
                    loop: false
                },
                {
                    name: "BN2_start_pt",
                    loop: false
                },
                {
                    name: "BN2_loop_win",
                    loop: true
                },
                {
                    name: "BN2_loop_win_pt",
                    loop: true
                },
            ],
            visible: false,
            defaultState: "main_loop",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "multi_effects",
            hasSkins: false,
            states: [
                {
                    name: "animation",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "animation",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "multi_merged",
            hasSkins: false,
            states: [
                {
                    name: "animation",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "animation",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "fsIntroOutro",
            hasSkins: true,
            skins: [
                {
                    name: "default",
                    states: ["intro_end", "intro_end_pt", "intro_loop", "intro_loop_pt", "intro_start", "intro_start_pt", "outro_end", "outro_end_pt", "outro_loop", "outro_loop_pt", "outro_start", "outro_start_pt"],
                },
                {
                    name: "black",
                    states: ["intro_end", "intro_end_pt", "intro_loop", "intro_loop_pt", "intro_start", "intro_start_pt", "outro_end", "outro_end_pt", "outro_loop", "outro_loop_pt", "outro_start", "outro_start_pt"],
                },
                {
                    name: "sticky",
                    states: ["intro_end", "intro_end_pt", "intro_loop", "intro_loop_pt", "intro_start", "intro_start_pt", "outro_end", "outro_end_pt", "outro_loop", "outro_loop_pt", "outro_start", "outro_start_pt"],
                },
            ],
            states: [
                {
                    name: "intro_end",
                    loop: false
                },
                {
                    name: "intro_end_pt",
                    loop: false
                },
                {
                    name: "intro_loop",
                    loop: true
                },
                {
                    name: "intro_loop_pt",
                    loop: true
                },
                {
                    name: "intro_start",
                    loop: false
                },
                {
                    name: "intro_start_pt",
                    loop: false
                },
                {
                    name: "outro_end",
                    loop: false
                },
                {
                    name: "outro_end_pt",
                    loop: false
                },
                {
                    name: "outro_loop",
                    loop: true
                },
                {
                    name: "outro_loop_pt",
                    loop: true
                },
                {
                    name: "outro_start",
                    loop: false
                },
                {
                    name: "outro_start_pt",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "intro_start",
            playDefault: false,
            forceRepositionContainer: false,
        },
    ];
}

export default new SpineAnimationsConfig()
